var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/macros/facet-option.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "category/templates/macros/facet-option.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("genericUrl")) {
var t_4 = t_1.genericUrl;
} else {
cb(new Error("cannot import 'genericUrl'")); return;
}
context.setVariable("genericUrl", t_4);
output += "\n\n";
var macro_t_5 = runtime.makeMacro(
["category", "facet", "displayName", "facetName", "facetValue"], 
["gaAttributes", "additionalClasses", "listItemDataAttributes", "inLineStyle", "refinementsCount"], 
function (l_category, l_facet, l_displayName, l_facetName, l_facetValue, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("category", l_category);
frame.set("facet", l_facet);
frame.set("displayName", l_displayName);
frame.set("facetName", l_facetName);
frame.set("facetValue", l_facetValue);
frame.set("gaAttributes", kwargs.hasOwnProperty("gaAttributes") ? kwargs["gaAttributes"] : "");
frame.set("additionalClasses", kwargs.hasOwnProperty("additionalClasses") ? kwargs["additionalClasses"] : "");
frame.set("listItemDataAttributes", kwargs.hasOwnProperty("listItemDataAttributes") ? kwargs["listItemDataAttributes"] : "");
frame.set("inLineStyle", kwargs.hasOwnProperty("inLineStyle") ? kwargs["inLineStyle"] : "");
frame.set("refinementsCount", kwargs.hasOwnProperty("refinementsCount") ? kwargs["refinementsCount"] : 0);
var t_6 = "";t_6 += "\n\n    ";
t_6 += "\n    ";
if(!runtime.contextOrFrameLookup(context, frame, "onlyShowSelections") || runtime.memberLookup((l_facet),"isSelected")) {
t_6 += "\n\n    <li class=\"c-facet c-facet--";
t_6 += runtime.suppressValue(l_facetName, env.opts.autoescape);
t_6 += " ";
if(runtime.memberLookup((l_facet),"isSelected")) {
t_6 += "is-selected";
;
}
t_6 += " js-facet js-facet__li\"\n        name=\"facet-option\"\n        data-qa-facet-value=\"";
t_6 += runtime.suppressValue(env.getFilter("escape_html_attributes").call(context, l_facetValue), env.opts.autoescape);
t_6 += "\"\n        data-facet-name=\"";
t_6 += runtime.suppressValue(env.getFilter("escape_html_attributes").call(context, l_facetName), env.opts.autoescape);
t_6 += "\"\n        ";
t_6 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "gaAttributes")), env.opts.autoescape);
t_6 += "\n        ";
t_6 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "listItemDataAttributes")), env.opts.autoescape);
t_6 += ">\n\n        <a href=\"";
t_6 += runtime.suppressValue((lineno = 20, colno = 28, runtime.callWrap(t_4, "genericUrl", context, [runtime.memberLookup((l_category),"catalogRequestPathname"),runtime.memberLookup((l_facet),"queryString"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core"),"excludeContextPath": runtime.contextOrFrameLookup(context, frame, "True")})])), env.opts.autoescape);
t_6 += "\"\n            data-query-string=\"";
t_6 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((l_facet),"queryString")), env.opts.autoescape);
t_6 += "\"\n            name=\"facet-";
t_6 += runtime.suppressValue(l_facetName, env.opts.autoescape);
t_6 += "-";
t_6 += runtime.suppressValue(env.getFilter("escape_html_attributes").call(context, l_facetValue), env.opts.autoescape);
t_6 += "\"\n            alt=\"";
t_6 += runtime.suppressValue(env.getFilter("escape_html_attributes").call(context, l_displayName), env.opts.autoescape);
t_6 += "\"\n            class=\"c-facet__a c-facet__a--";
t_6 += runtime.suppressValue(l_facetName, env.opts.autoescape);
t_6 += " js-facet__a";
if(runtime.memberLookup((l_facet),"isSelected")) {
t_6 += " is-selected ";
;
}
t_6 += " ";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "additionalClasses"), env.opts.autoescape);
t_6 += "\"\n            ";
if(runtime.memberLookup((l_facet),"isSelected")) {
t_6 += "\n                aria-selected=\"true\"\n            ";
;
}
t_6 += "\n            data-cm-element=\"category_facet_";
t_6 += runtime.suppressValue(l_facetName, env.opts.autoescape);
t_6 += "\"\n            data-element-name=\"";
t_6 += runtime.suppressValue(l_facetName, env.opts.autoescape);
t_6 += "\" ";
if(!(lineno = 29, colno = 65, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [l_category,"filtersAreCrawlableAtThisDepth"]))) {
t_6 += "rel=\"nofollow\" ";
;
}
t_6 += "\n            ";
if(runtime.memberLookup((l_facet),"isSelected")) {
t_6 += "data-qa-selected-facet";
;
}
t_6 += ">\n            <span title=\"";
t_6 += runtime.suppressValue(l_facetValue, env.opts.autoescape);
t_6 += "\" class=\"c-facet__";
t_6 += runtime.suppressValue(env.getFilter("escape_html_attributes").call(context, l_facetName), env.opts.autoescape);
t_6 += "-outer\">\n\n                <span class=\"c-facet__";
t_6 += runtime.suppressValue(env.getFilter("escape_html_attributes").call(context, l_facetName), env.opts.autoescape);
t_6 += "-swatch\" ";
t_6 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "inLineStyle")), env.opts.autoescape);
t_6 += "></span>\n\n                <span class=\"c-facet__";
t_6 += runtime.suppressValue(env.getFilter("escape_html_attributes").call(context, l_facetName), env.opts.autoescape);
t_6 += "-label\">\n\n                    ";
t_6 += runtime.suppressValue(l_displayName, env.opts.autoescape);
if(env.getFilter("int").call(context, runtime.contextOrFrameLookup(context, frame, "refinementsCount")) > 0 && !runtime.memberLookup((l_facet),"isSelected")) {
t_6 += "<span class=\"c-facet__refinement-count\">(";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "refinementsCount"), env.opts.autoescape);
t_6 += ")</span>\n                    ";
;
}
t_6 += "\n\n                </span>\n\n            </span>\n\n        </a>\n\n    </li>\n\n    ";
;
}
t_6 += "\n\n";
;
frame = frame.pop();
return new runtime.SafeString(t_6);
});
context.addExport("facetOption");
context.setVariable("facetOption", macro_t_5);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/macros/facet-option.j2"] , dependencies)